import {
  ApiCartUpdateCartEntryQuantityRequestedAction,
  apiCartUpdateCartEntryQuantityFailed,
  apiCartUpdateCartEntryQuantitySucceeded
} from '../../../api/cart/updateCartEntryQuantityApi';
import { call, put } from 'typed-redux-saga';
import updateCartEntryQuantityAction, {
  UpdateCartEntryQuantityActionInput
} from '@spa/lib/actions/cart/updateCartEntryQuantityAction';
import { UpdateCartEntryQuantityResult } from '@spa/lib/graphql/cart/updateProductQuantityInCartEntry';

function* updateCartEntryQuantitySaga({
  payload: { entryId, customOrderType, parentActionId, actionId: requestedActionId, quantity }
}: ApiCartUpdateCartEntryQuantityRequestedAction): Generator {
  try {
    const input: UpdateCartEntryQuantityActionInput = { customOrderType, entryId, quantity };
    const result: UpdateCartEntryQuantityResult = yield* call(
      updateCartEntryQuantityAction,
      'updateCartEntryQuantityAction',
      input
    );

    yield* put(
      apiCartUpdateCartEntryQuantitySucceeded({
        requestedActionId,
        parentActionId,
        result,
        cartId: result.cart.code,
        entryId,
        quantity
      })
    );
  } catch {
    yield* put(
      apiCartUpdateCartEntryQuantityFailed({
        requestedActionId,
        parentActionId
      })
    );
  }
}

export default updateCartEntryQuantitySaga;
